import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useUser } from './UserContext';

export default function AuthNavbar() {
  const { user, logout } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const links = [
    { to: '/firmen-homepages', text: 'Firmen Homepages', icon: '🏢' },
    { to: '/firmen-list', text: 'Firmenliste', icon: '📋' },
    { to: '/firma/register', text: 'Firma anmelden', icon: '➕' }
  ];

  const userLinks = user ? [
    ...(user.rolle === 'ADMIN' ? [
      { to: '/admin/public-list', text: 'Öffentliche Liste', icon: '📋', className: 'admin-link' },
      { to: '/admin/create-private-firma', text: 'Private Firmen erstellen', icon: '➕', className: 'admin-link' },
    ] : []),
    ...(user.rolle === 'TEACHER' || user.rolle === 'ADMIN' ? [
      { to: '/private-firmen', text: 'Private Firmen', icon: '🔒' }
    ] : []),
  ] : [];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        {/* Hamburger nur auf Mobile */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div></div><div></div><div></div>
        </div>

        {/* Navigation Links */}
        <div className="nav-section nav-section-center">
          <ul className={`nav-menu ${menuOpen ? 'open' : ''}`}>
            {links.map((link, index) => (
              <li key={index}>
                <Link
                  to={link.to}
                  className={`nav-link ${isActive(link.to) ? 'active' : ''}`}
                  onClick={() => setMenuOpen(false)}
                >
                  <span className="nav-icon">{link.icon}</span>
                  <span className="nav-text">{link.text}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* User Section */}
        <div className="nav-section nav-section-right">
          {user ? (
            <div className="user-dropdown">
              <button
                className="user-button"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                aria-expanded={isDropdownOpen}
              >
                <span className="user-avatar">👤</span>
                <span className="user-info">
                  <span className="username">{user.username}</span>
                  <span className="user-role">{user.rolle}</span>
                </span>
              </button>
              {isDropdownOpen && (
                <div className="dropdown-menu">
                  <div className="user-profile">
                    <div className="user-email">{user.email}</div>
                    <div className="user-role-badge">{user.rolle}</div>
                  </div>
                  <div className="dropdown-divider"></div>
                  {userLinks.map((link, index) => (
                    <Link
                      key={index}
                      to={link.to}
                      className="dropdown-item"
                      onClick={() => setIsDropdownOpen(false)}
                    >
                      <span className="nav-icon">{link.icon}</span>
                      <span>{link.text}</span>
                    </Link>
                  ))}
                  <div className="dropdown-divider"></div>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      handleLogout();
                      setIsDropdownOpen(false);
                    }}
                  >
                    <span className="nav-icon">🚪</span>
                    <span>Abmelden</span>
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="auth-buttons">
              <Link
                to="/register"
                className="btn btn-outline btn-sm"
              >
                Registrieren
              </Link>
              <Link
                to="/login"
                className="btn btn-primary btn-sm"
              >
                Anmelden
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
